var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chat-window',{attrs:{"messages":_vm.messages,"requestUrl":_vm.requestUrl,"requestParams":_vm.requestParams,"focus":_vm.focus,"saveOnDestroy":true,"errorName":"note","placeholder":"Write note"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af2c5988","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-components/activity-notes/components/activity-notes.vue
// module id = 7ud0
// module chunks = 1